import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "stacking-pdp-header flex-column-between" }
const _hoisted_2 = { class: "stacking-pdp-titles-container flex-column-center" }
const _hoisted_3 = { class: "stacking-pdp-titles flex-column-center" }
const _hoisted_4 = { class: "stacking-pdp-title flex-center" }
const _hoisted_5 = { class: "stacking-pdp-subtitle font-14 PingFangSC-Regular" }
const _hoisted_6 = { class: "stacking-pdp-item-infos-container flex-column-center" }
const _hoisted_7 = { class: "stacking-pdp-item-infos flex-column-center" }
const _hoisted_8 = { class: "product-name flex-center" }
const _hoisted_9 = { class: "product-desc font-14 PingFangSC-Regular" }
const _hoisted_10 = { class: "product-poster flex-column-center" }
const _hoisted_11 = { class: "product-tool" }
const _hoisted_12 = { class: "product-tool-price font-14 ABChanelCorpo-2022-Regular" }
const _hoisted_13 = ["onClick"]

import { getStackingProductImage } from '@/utils/image'
import { computed } from 'vue'
import { namedImages, useConfAndQueryStore, useStackingStore } from '@/store'
import { throttle } from '@/utils'
import { ClickAction } from '@/data/report'
import { PosterName } from '@/data/images'
import { isIOS, win } from '@/utils/device'

export default /*@__PURE__*/_defineComponent({
  __name: 'StatkingContent',
  setup(__props) {

const { report } = useConfAndQueryStore()
const stackingStore = useStackingStore()

const stackingInfo = computed(() => {
  // console.log(stackingStore.selectedStacking, stackingStore.selectedStackingSet)
  return {
    titleString: stackingStore.selectedStacking?.titleString,
    titleFragments: (stackingStore.selectedStacking?.title || []).map(
      ({
        text,
        isAsciiOrExtended
      }: {
        text: string
        isAsciiOrExtended: boolean
      }) => ({
        text,
        typo: isAsciiOrExtended
          ? 'ABChanelCorpo-2022-Regular font-18'
          : 'PingFangSC-Medium font-16'
      })
    ),
    banner: stackingStore.selectedStacking?.code
      ? namedImages[
          `${stackingStore.selectedStacking.code}_banner` as PosterName
        ]
      : '',
    productLine: stackingStore.selectedStackingSet?.title[0] || '',
    products: stackingStore.selectedStacking?.products || []
  }
})
const gotoPdp = throttle(skuId => {
  if (stackingInfo.value.titleString) {
    console.log('[[ Weixin ] Goto PDP of Stacking ]', { skuId })
    report(ClickAction.JUMP_TO_WORK, [stackingInfo.value.titleString, skuId])
    win.wx?.miniProgram?.navigateTo({
      url: `/pages/pdp-new/index?pdp=${skuId}&from=vto-hub-stacking`
    })
  }
}, 1000)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["stacking-pdp flex-column-center", { 'is-ios': _unref(isIOS) }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "stacking-pdp-poster",
        style: _normalizeStyle(`background-image: url(${stackingInfo.value.banner})`)
      }, null, 4),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stackingInfo.value.titleFragments, (fragment, index) => {
              return (_openBlock(), _createElementBlock("span", {
                key: index,
                class: _normalizeClass(fragment.typo)
              }, _toDisplayString(fragment.text), 3))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_5, _toDisplayString(stackingInfo.value.productLine), 1)
        ])
      ]),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "stacking-pdp-line" }, null, -1))
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stackingInfo.value.products, (product, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["stacking-pdp-item flex-column-center", {
        first: index === 0
      }]),
        key: product.skuId
      }, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product.title, (fragment, index) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: index,
                  class: _normalizeClass(
                fragment.isAsciiOrExtended
                  ? 'ABChanelCorpo-2022-Regular font-18'
                  : 'PingFangSC-SemiBold font-16'
              )
                }, _toDisplayString(fragment.text), 3))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_9, _toDisplayString(product.content), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", {
            class: "product-poster-image",
            style: _normalizeStyle(`background-image: url(${_unref(getStackingProductImage)(
            product.skuId
          )})`)
          }, null, 4)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, _toDisplayString(product.priceString), 1),
          _createElementVNode("div", {
            class: "product-tool-btn",
            "data-is-touchable": "clickable",
            onClick: ($event: any) => (_unref(gotoPdp)(product.skuId))
          }, _cache[1] || (_cache[1] = [
            _createElementVNode("div", { class: "tool-btn-text font-14" }, "探索作品", -1),
            _createElementVNode("div", { class: "tool-btn-line" }, null, -1)
          ]), 8, _hoisted_13)
        ])
      ], 2))
    }), 128))
  ], 2))
}
}

})